import { Component, EventEmitter, HostListener, Input, NgZone, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { TipoCuentaAbonoEnum } from 'src/app/global/enums/tipo-cuenta-abono.enum';
import { BancoResponse } from 'src/app/global/interfaces/banco-response';
import { Paso1Login } from 'src/app/global/interfaces/paso-1-login';
import { Paso2 } from 'src/app/global/interfaces/paso-2';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { CuentaAbonoSubject } from 'src/app/global/services/cuenta-abono-subject.service';
import { FlujosPaso2PJService } from 'src/app/global/services/flujos-paso-2-pj.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { cuentaBancaria } from 'src/app/messages/step-2-messages';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { CuentaAbonoServiceVM } from 'src/app/view-model/services/cuenta-abono-vm.service';
import { GoToPaso3ServiceVM } from 'src/app/view-model/services/go-to-paso3.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';
import { TipoCuenta } from 'src/app/global/interfaces/tipo-cuenta';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { first } from 'rxjs/operators';
import { clipBoardIPJ } from 'src/app/global/interfaces/cuenta-abono.response';
import { Paso1 } from 'src/app/global/interfaces/paso-1';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cuenta-bancaria-pj',
  templateUrl: './cuenta-bancaria-pj.component.html',
  styleUrls: ['./cuenta-bancaria-pj.component.scss']
})
export class CuentaBancariaPJComponent implements OnInit, OnDestroy {

  TipoCuentaAbonoEnum = TipoCuentaAbonoEnum;
  ocultarPasos: boolean;
  showPasos = 0;
  public mensajeErrorCuentaBancaria = cuentaBancaria;
  bancos: BancoResponse[] = [];
  tiposCuenta:TipoCuenta[] = [];
  tiposCuentasDefinidos:TipoCuenta[] = [];
   form: FormGroup ;
  currentForm: FormGroup ;
  oneClick = false;
  changedAccount = false;
  rutContratacion = '';
  runLogin = '';
  paso1: Paso1Login;
  paso1login: Paso1;
  paso2: Paso2;
  product: Product;
  cuentaAbonoInicial = 'CUENTA_EMPRESA';
  rutEmpresa = false;
  screenSize: number;
  @Input() showCantidadCampos = true;
  continueCuentaEmpresa = false;
  processing = false;
  processingCall = false;
  rutDeContratacion: unknown = '';
  continueForm: boolean = true;
  private hasRun: boolean = false;
  message = 'Recibirás los abonos en una cuenta que está a tu nombre';
  idBanco: number;
  loading = false;
  private clickTimeout = null;
  tipoCuenta: string;
  private subscription: Subscription;
  private subscription2: Subscription;
  disableNumeroCuenta = false;
  dataParsedClipboard: clipBoardIPJ;
  isFromClipboard: boolean =  false;

  constructor(private cuentaAbonoServiceVM: CuentaAbonoServiceVM,
              private cuentaAbonoSubject: CuentaAbonoSubject,
              private flujosPaso2PJServ: FlujosPaso2PJService,
              private ngZone: NgZone,
              private rutFormatter: RutFormatterService,
              private dialogServ: DialogService,
              private productService: vmProductosService,
              private rutFormatterService: RutFormatterService,
              private gotoPaso3Service: GoToPaso3ServiceVM,
              private tagM: TagManagerService,
              private stepperService: StepperServiceVM,
              private storage: LocalStorageService) 
              {
    this.form = this.cuentaAbonoServiceVM.createFormPJ() as FormGroup;
    this.currentForm = this.form.get('cuentaEmpresa') as FormGroup;
  }

  @HostListener('window:resize', ['$event'])
  cambiaAnchura() {
    this.screenSize = window.innerWidth;
    if (this.isLowRes()) {
      this.showPasos = 0;
    }
  }

  private isLowRes(): boolean {
    if (this.screenSize < 768) {
      return true;
    } else {
      return false;
    }
  }

ngOnInit() {
  this.currentForm = this.form.get('cuentaEmpresa') as FormGroup;

  /*this.subscription2 = this.currentForm.get('rutEmpresa').valueChanges.subscribe(() => {
    this.determineCuentaEnvio();
  });*/

  this.currentForm.get('bancos').valueChanges.subscribe(bancoId => {
    this.recargarBancos(bancoId);
  });

  this.currentForm.get('tipoCuenta').valueChanges.subscribe(() => {
    this.isCuentaRut();
  });

  


  this.paso1login = this.storage.getPaso1();
  this.runLogin = this.paso1login.run + '';

  this.currentForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_EMPRESA);

 /* this.subscription = this.currentForm.valueChanges.subscribe(form => {
    this.currentForm = form.seleccionarCuenta === 'CUENTA_EMPRESA'
      ? this.form.get('cuentaEmpresa') as FormGroup
      : this.form.get('cuentaTerceros') as FormGroup;
  });
  */

}


  async init() {
    this.ngZone.run(async () => {
      try {
        this.paso2 = this.storage.getPaso2();
        this.flujosPaso2PJServ.cuentaBancaria.bloqueado = false;
        const bancos = await this.cuentaAbonoServiceVM.bancos().toPromise();
        this.bancos = bancos;
        this.cambiaNombreCuentaBancos();
        const cuentaAbono = await this.cuentaAbonoServiceVM.getCuentaAbono().toPromise();
        this.rutContratacion = this.currentForm.get('rutEmpresa').value;
        const intRun = _.get(cuentaAbono, 'run', 0);
        const dv = this.rutFormatter.getDv(intRun);
        const run = `${intRun}-${dv}`;

        if (cuentaAbono) {
          if (cuentaAbono.tipoPropietario === 'PROPIA') {
            this.cuentaAbonoInicial = 'CUENTA_EMPRESA';
            this.currentForm = this.form.get('cuentaEmpresa') as FormGroup;
            this.currentForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_EMPRESA);
            this.currentForm.get('rutEmpresa').setValue(run);
            this.currentForm.get('razonSocial').setValue(_.get(cuentaAbono, 'razonSocial', ''));

            this.currentForm.get('bancos').setValue(_.get(cuentaAbono, 'banco.id', ''));
            this.currentForm.get('tipoCuenta').setValue(cuentaAbono.banco.relacion[0].id);
            this.currentForm.get('numeroCuenta').setValue(_.get(cuentaAbono, 'numero', ''));
            this.config();
            this.flujosPaso2PJServ.cuentaBancaria.cargando = false;
            this.flujosPaso2PJServ.cuentaBancaria.mostrar = true;
          } else {
            this.cuentaAbonoInicial = 'CUENTA_TERCEROS';
            this.currentForm = this.form.get('cuentaTerceros') as FormGroup;
            this.currentForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_TERCEROS);

            const intRun = _.get(cuentaAbono, 'run', 0);
            const dv = this.rutFormatter.getDv(intRun);
            const run = `${intRun}-${dv}`;

            this.currentForm.get('rutEmpresa').setValue(this.rutFormatterService.format(run));

            const runNumbers = this.rutFormatterService.getRutFormats(this.currentForm.get('rutEmpresa').value);
            const rut = runNumbers.numbers;

            if (this.runEsEmpresa(rut)) {
              this.currentForm.get('nombresTitular').setValue(_.get(cuentaAbono, 'razonSocial', ''));
            } else {
              this.currentForm.get('nombresTitular').setValue(_.get(cuentaAbono, 'nombre.nombres', ''));
            }

            this.currentForm.get('primerApellido').setValue(_.get(cuentaAbono, 'nombre.apellidoPaterno', ''));
            this.currentForm.get('segundoApellido').setValue(_.get(cuentaAbono, 'nombre.apellidoMaterno', ''));
            setTimeout(() => {
              this.currentForm.get('bancos').setValue(_.get(cuentaAbono, 'banco.id', ''));
              this.currentForm.get('tipoCuenta').setValue(cuentaAbono.banco.relacion[0].id);
              this.currentForm.get('numeroCuenta').setValue(_.get(cuentaAbono, 'numero', ''));

              this.config();
              this.flujosPaso2PJServ.cuentaBancaria.cargando = false;
              this.flujosPaso2PJServ.cuentaBancaria.mostrar = true;
            }, 1000);
          }
        } else {
          this.config();
          this.cuentaAbonoServiceVM.loadForm(this.currentForm, false, true);
          this.rutContratacion = this.currentForm.get('rutEmpresa').value;
          this.flujosPaso2PJServ.cuentaBancaria.cargando = false;
          this.flujosPaso2PJServ.cuentaBancaria.mostrar = true;
          //modal y funcion getClipboard
          this.abrirModal();
        }
      } catch (error) {
        console.error(error);
        this.tagM.logError('Paso 2', error.statusText, error.message);
      }
    });

  }

  private runEsEmpresa(rut: number) {
    return rut >= 50000000;
  }

  config() {
    //this.currentForm.get('rutEmpresa').setValue(this.runLogin, { emitEvent: false });
    const razonSocial = this.paso2.datosComercio.razonSocial;
    this.currentForm.get('razonSocial').setValue(razonSocial);
    this.processing = true;
    if (this.currentForm.get('rutEmpresa').value !== '' && this.currentForm.get('rutEmpresa').value !== null) {
      const runNumbers = this.rutFormatterService.getRutFormats(this.currentForm.get('rutEmpresa').value);
      const run = runNumbers.numbers;
      if (run >= 50000000) {
        //this.currentForm.get('razonSocial').setValue('vacio');
        //this.currentForm.get('primerApellido').setValue('vacio');
        //this.currentForm.get('segundoApellido').setValue('vacio');
      }
    }

    this.cuentaAbonoSubject.hideObservable$.subscribe(res => this.ocultarPasos = res);

    /*this.subscription = this.form.valueChanges.subscribe((form) => {
      if (form.seleccionarCuenta === TipoCuentaAbonoEnum.CUENTA_EMPRESA) {
        this.currentForm = this.form.get('cuentaEmpresa') as FormGroup;
      } else {
        this.currentForm = this.form.get('cuentaTerceros') as FormGroup;
      }
    });*/

  }
  
  rutprevio='';
  private determineCuentaEnvio(): void {

    const rut = this.currentForm.get('rutEmpresa').value || '';
    if(this.rutprevio === rut){
        return ;
    }
    this.isFromClipboard = false;
    // Procesar y validar el RUT ingresado
    const runBody = this.getRutBodyIfValid(rut);

    // Convertir los cuerpos del RUT a números enteros
    const run = parseInt(runBody, 10);

    const rutcontrata =  Number(this.runLogin.split('-')[0].split('.').join(''));

    // Lógica para determinar el tipo de cuenta
    switch (true) {
        // Caso 1: Cuenta Empresa Propia
        case run === rutcontrata:
            console.warn("Es una Cuenta Empresa Propia");
            this.currentForm = this.form.get('cuentaEmpresa') as FormGroup    
            this.currentForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_EMPRESA);
            this.rutEmpresa = false;
            this.isCuentaRut();
            this.currentForm.get('rutEmpresa').setValue(rut, { emitEvent: false });
            this.currentForm.get('primerApellido').setValue('vacio');
            this.currentForm.get('segundoApellido').setValue('vacio');
            this.config(); 
             // Si los datos provienen del portapapeles, los inyectamos en el formulario:
            if (this.isFromClipboard && this.dataParsedClipboard) {
              this.confirmClipboad(this.dataParsedClipboard);
              this.dataParsedClipboard = null;
              this.isFromClipboard = false;
            }
            console.log("Valores del form luego de confirmClipboad:", this.currentForm.value);
            break;

        // Caso 2: Cuenta Empresa
        case run > 50000000:
            console.warn("Es una Cuenta Empresa");
            this.currentForm = this.form.get('cuentaEmpresa') as FormGroup;
            this.currentForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_EMPRESA);
            this.rutEmpresa = false;
            //this.config();
            this.isCuentaRut();
            this.currentForm.get('rutEmpresa').setValue(rut, { emitEvent: false });
            this.currentForm.get('razonSocial').setValue('');
            this.currentForm.get('bancos').setValue('');
            this.currentForm.get('tipoCuenta').setValue('');
            this.currentForm.get('numeroCuenta').setValue('');
            this.processing = false;
            // Si los datos provienen del portapapeles, los inyectamos en el formulario:
            if (this.isFromClipboard && this.dataParsedClipboard) {
              this.confirmClipboad(this.dataParsedClipboard);
              this.dataParsedClipboard = null;
              this.isFromClipboard = false;
            }
            console.log("Valores del form luego de confirmClipboad:", this.currentForm.value);
            break;

        // Caso 3: Cuenta Terceros
        case run < 50000000:
            console.warn("Es una Cuenta de Terceros");
            this.currentForm = this.form.get('cuentaTerceros') as FormGroup;
            this.currentForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_TERCEROS);
            this.currentForm.get('rutEmpresa').setValue(rut, { emitEvent: false });
            this.rutEmpresa = true;
            this.processing = false;
            this.currentForm.get('razonSocial').setValue('');
            this.currentForm.get('razonSocial').valueChanges.subscribe(((value)=>{
              console.log("razonSocial value:",value);
              this.currentForm.get('nombresTitular').setValue(value);
            }))
            this.currentForm.get('primerApellido').setValue('');
            this.currentForm.get('segundoApellido').setValue('');            
            this.currentForm.get('rutEmpresa').setValue(rut, { emitEvent: false });
            this.isCuentaRut();
            // Si los datos provienen del portapapeles, los inyectamos en el formulario:
            if (this.isFromClipboard && this.dataParsedClipboard) {
              this.confirmClipboad(this.dataParsedClipboard);
              this.dataParsedClipboard = null;
              this.isFromClipboard = false;
            }
            console.log("Valores del form luego de confirmClipboad:", this.currentForm.value);
            break;

        default:
            console.error("RUT no válido");
            break;
    }

    this.rutprevio=this.currentForm.get('rutEmpresa').value;
}

  private getRutBodyIfValid(rut: string): string {
    // Eliminar todos los caracteres que no sean dígitos o 'K'
    const cleanRut = rut.replace(/[^0-9kK]/g, '');
    // Separar el cuerpo del RUT y el dígito verificador
    const body = cleanRut.slice(0, -1);
    const dv = cleanRut.slice(-1).toUpperCase();

    // Validar que el cuerpo del RUT tenga al menos un dígito
    if (body.length < 1) {
        throw new Error("El RUT proporcionado es demasiado corto");
    }

    // Calcular el dígito verificador esperado
    const expectedDv = this.rutFormatter.getDv(Number(body)).toString().toUpperCase();

    // Validar el dígito verificador
    if (expectedDv !== dv) {
        throw new Error(`Dígito verificador incorrecto para el RUT ${rut}`);
    }

    // Retornar el cuerpo del RUT si es válido
    return body;
}

  get esCuentaEmpresa(): boolean {
    const cuenta = this.currentForm.get('seleccionarCuenta').value;
    let esCuentaEmpresa = false;
    if (cuenta === TipoCuentaAbonoEnum.CUENTA_EMPRESA) {
      esCuentaEmpresa = true;
    }
    return esCuentaEmpresa;
  }

  save() {
    
    if (this.esCuentaEmpresa) {
      this.saveCuentaEmpresa();
      console.warn("iniciando guardado saveCuentaEmpresa")
    } else {
      console.warn("iniciando guardado saveCuentaTerceros")
      this.saveCuentaTerceros();
      
      
    }
  }

  registraSeleccionProducto() {
    try {
      this.productService.registraSeleccionProductoActual().toPromise();
    } catch (error) {
      this.tagM.logError('Paso 2', error.statusText, error.message);
    }
  }

  async saveCuentaEmpresa() {
    try {
      this.processingCall=true;
      console.warn("iniciando guardado saveCuentaEmpresa")
      await this.cuentaAbonoServiceVM.saveForm(this.currentForm);
      this.tagM.logDL_cuentaAbono(this.esCuentaEmpresa);
      this.goToPaso3();
    } catch (error) {
      this.processingCall=false;
      this.processing = false;
      this.tagM.logError('Paso 2', error.statusText, error.message);
    }
  }

  async saveCuentaTerceros() {
    try {
      this.processingCall=true;
      console.warn("iniciando guardado saveCuentaTerceros")
      this.currentForm.get('nombresTitular').setValue(this.currentForm.get('razonSocial').value);
      await this.cuentaAbonoServiceVM.saveForm(this.currentForm);
      this.tagM.logDL_cuentaAbono(this.esCuentaEmpresa);
      this.goToPaso3();
    } catch (error) {
      this.processingCall=false;
      this.processing = false;
      this.tagM.logError('Paso 2', error.statusText, error.message);
    }
  }

  private async goToPaso3() {
    console.warn("iniciando goToPaso3")
    try {
      this.tagM.logEvent(GoogleTagManager.eventInteracciones().categoriaCuentaBancaria().setAccion("click").setEtiqueta("continuar"))
      const respuesta = await this.gotoPaso3Service.goToPaso3();
      if (respuesta === 'GOTO_PASO_3') {
        this.stepperService.nextStep();
      }
    } catch (e) {
      console.error('Error final: ', e);
    }

  }

  get flujos() { return this.flujosPaso2PJServ; }

  onIngresarCuentaEmpresa(value: boolean): void {
    this.currentForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_EMPRESA);
    this.continueCuentaEmpresa = true;
    this.config();
  }

  hideDatos(cuenta: string) {
    if (!(cuenta === this.cuentaAbonoInicial)) {
      this.changedAccount = true;
    }

    if (cuenta === 'CUENTA_EMPRESA') {
      this.showPasos = 0;
    } else {
      if (!this.isLowRes()) {
        this.showPasos = 1;
      } else {
        this.showPasos = 0;
      }
    }
    this.config();
    this.ocultarPasos = false;
  }

  cambiaNombreCuentaBancos(){
    //Banco de Chile
    var indexBanco = this.bancos.findIndex((b => b.id === 24))
    var indexRelacion = this.bancos[indexBanco].relacion.findIndex ((r => r.id = "CORRIENTE"));
    this.bancos[indexBanco].relacion[indexRelacion].descripcion = "Cuenta Corriente / Cuenta Vista";

    //Banco BCI
    indexBanco = this.bancos.findIndex((b => b.id === 2))
    indexRelacion = this.bancos[indexBanco].relacion.findIndex ((r => r.id = "CORRIENTE"));
    this.bancos[indexBanco].relacion[indexRelacion].descripcion = "Cuenta Corriente / Cuenta Vista";
  }


/* logica form  */

get rutEmpresaControl(): FormControl {
  return this.currentForm.get('rutEmpresa') as FormControl;
}

recargarBancos(bancoId: unknown) {
  const bancoSeleccionado = this.bancos.find((i) => Number(i.id) === Number(bancoId));
  if (bancoSeleccionado) {
    const rut = this.rutFormatter.format(this.rutEmpresaControl.value);
    if (Number(bancoId) === 12 && this.rutFormatter.getRutFormats(rut).numbers >= 50000000) {
      this.tiposCuenta = [];
      this.tiposCuenta[0] = bancoSeleccionado.relacion[0];
    } else {
      this.tiposCuenta = bancoSeleccionado.relacion;
    }
  } else {
    this.tiposCuenta = [];
  }
}

continue(): void {
  this.continueForm = true;
  if (this.changedAccount) {
    this.limpiarCampos();
  }

  this.cuentaAbonoSubject.showPasosCuenta();
  this.cuentaAbonoSubject.showNumberPasos(3);
}

private limpiarCampos() {
  this.currentForm.get('bancos').reset();
  this.currentForm.get('bancos').setValue('');
  this.currentForm.get('tipoCuenta').reset();
  this.currentForm.get('tipoCuenta').setValue('');
  this.currentForm.get('numeroCuenta').reset();
  this.currentForm.get('autorizar').reset();
}



ContinuarGuardar($event: any) {
  $event.stopPropagation();
  if (this.currentForm.valid) {
    this.clickTimeout = setTimeout(() => this.onSaveClick(), 100);
  }
}

onSaveClick() {
  this.modalConfirmardatos();
}

ngOnDestroy(): void {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
  if (this.subscription2) {
    this.subscription2.unsubscribe();
  }
}

isCuentaRut() {
  this.idBanco = Number(this.currentForm.get('bancos').value);
  if (this.idBanco === 12 && this.currentForm.get('tipoCuenta').value === 'RUT') {
    const cuentaRut = this.rutFormatter.getRutFormats(this.currentForm.get('rutEmpresa').value).numbers;
    this.currentForm.get('numeroCuenta').setValue(cuentaRut);
    this.disableNumeroCuenta = true;
    this.processing = true;
  } else {
    //this.currentForm.get('numeroCuenta').setValue('');
    this.disableNumeroCuenta = false;
  }
}


  /* Modal init */

  abrirModal() {
    ($('#clipboardModal') as any).modal('show');
  }

  cerrarModal() {
    //console.warn('Permitir acceso al portapapeles');
    ($('#clipboardModal') as any).modal('hide'); 
    this.modalCopiardatos();
  }


  levantaInput() {
    if (this.hasRun) {
      return;
    }
    this.modalCopiardatos();
    this.determineCuentaEnvio();
    this.hasRun = true;
  }


  /* Modal pegar */
  modalCopiardatos() {
    navigator.clipboard.readText().then((text) => {
      const dataParsed = this.parseClipboardText(text);
      this.dataParsedClipboard = dataParsed;
      this.isFromClipboard = true;

      const data = {
        title: 'Copia y pega tus datos bancarios',
        description: `
        <strong>Activa y usa los datos desde el portapapeles</strong> <br><br>
        Para activar la función pegar datos bancarios, presiona el botón Permitir que aparece arriba en tu navegador. <br><br>
        <strong>¿Deseas utilizar estos datos?</strong><br><br>
        <div class="card cardcuenta" style="width: 18rem;">
        <div class="card-body">
        <table class="table table-sm table-borderless" style="width:100%;">
          <tr>
            <td style="  padding: 8px;">Nombre</td>
            <td style="  padding: 8px;">${dataParsed.razonSocial ? dataParsed.razonSocial : 'No disponible'}</td>
          </tr>
         
          <tr>
            <td style="  padding: 8px;">RUT</td>
            <td style="  padding: 8px;">${dataParsed.rutEmpresa ? dataParsed.rutEmpresa : 'No disponible'}</td>
          </tr>
          <tr>
            <td style="  padding: 8px;">Cuenta</td>
            <td style="  padding: 8px;">${dataParsed.cuenta ? dataParsed.cuenta : 'No disponible'}</td>
          </tr>
          <tr>
            <td style="  padding: 8px;">Banco</td>
           <td style="  padding: 8px;">${dataParsed.banco && dataParsed.banco.descripcion ? dataParsed.banco.descripcion : 'No disponible'}</td>
          </tr>
          <tr>
            <td style="  padding: 8px;">Tipo de Cuenta</td>
           <td style="  padding: 8px;">${dataParsed.tipoCuenta ? dataParsed.tipoCuenta.descripcion : 'No disponible'}</td>
          </tr>
        </table></div></div><br><br>
      `,
        cancelButton: 'No por ahora',
        actionButton: 'Si, utilizar'
      };

      this.dialogServ.openTwoActionsDialog({ data }).afterClosed().subscribe(async (action) => {
        if (action.action === 'OK') {
         // this.getClipboard();
          this.confirmClipboad(dataParsed);
          this.determineCuentaEnvio();
        }
      });
    }).catch(err => {
      console.error('Failed to read clipboard contents: ', err);
    });
  }

  private confirmClipboad(dataParsed:clipBoardIPJ){

    this.currentForm.get('rutEmpresa').setValue(dataParsed.rutEmpresa);

    const run =dataParsed.rutEmpresa.split('-')[0]? Number(dataParsed.rutEmpresa.split('-')[0].split('.').join('')):0

    this.currentForm.get('razonSocial').setValue(this.runEsEmpresa(run)? dataParsed.razonSocial:dataParsed.nombre.nombresTitular);
    this.currentForm.get('primerApellido').setValue(dataParsed.nombre.primerApellido);
    this.currentForm.get('segundoApellido').setValue(dataParsed.nombre.segundoApellido);
    this.currentForm.get('bancos').valueChanges.pipe(first()).subscribe(()=>{
      this.currentForm.get('tipoCuenta').setValue(dataParsed.tipoCuenta);
    });
    this.currentForm.get('bancos').setValue(dataParsed.banco.id);
    this.currentForm.get('tipoCuenta').setValue(dataParsed.tipoCuenta);
    this.currentForm.get('numeroCuenta').setValue(dataParsed.cuenta);
 }


/* Modal pegar */
modalConfirmardatos() {
  // Obtén los valores del formulario
  const dataParsed = this.currentForm.value;
  const bancoID =Number(dataParsed.bancos);

  const bancoElegido =this.bancos.find(banco=>banco.id===bancoID);
  const tipCuentaElegida =this.tiposCuenta.find(tipoCuenta=>tipoCuenta.id===dataParsed.tipoCuenta);

  const data = {
    title: 'Confirmación de datos',
    description: `Revisa y confirma que los datos ingresados son correctos antes de continuar. <br><br>
    <div class="alert  border rounded" role="alert">
    <div class="mr-2 infoicon"> </div>
    El abono de tu dinero no será efectuado, si estos datos no corresponden a una cuenta bancaria, existente y con vigencia.
    </div>
      <div class="card cardcuenta" style="width: 18rem;">
        <div class="card-body">
          <table class="table table-sm table-borderless" style="width:100%;">
            <tr>
              <td style="padding: 8px;">Nombre</td>
              <td style="padding: 8px;">${dataParsed.razonSocial ? dataParsed.razonSocial : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">RUT</td>
              <td style="padding: 8px;">${dataParsed.rutEmpresa ? dataParsed.rutEmpresa : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Cuenta</td>
              <td style="padding: 8px;">${dataParsed.numeroCuenta ? dataParsed.numeroCuenta : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Banco</td>
              <td style="padding: 8px;">${bancoElegido ? bancoElegido.asString : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Tipo de Cuenta</td>
              <td style="padding: 8px;">${tipCuentaElegida ? tipCuentaElegida.descripcion : 'No disponible'}</td>
            </tr>
          </table>
        </div>
      </div><br><br>
    `,
    cancelButton: 'Editar datos',
    actionButton: 'Confirmar'
  };

  this.dialogServ.openTwoActionsDialog({ data }).afterClosed().subscribe(async (action) => {
    if (action.action  === 'OK') {
      this.loading = true;
      this.processing = true;
      //this.determineCuentaEnvio();
      //this.cerrarModal();
      ($('#clipboardModal') as any).modal('hide'); 
      this.save();
    }
  });
}
goToLogin(): void {
  location.href = environment.redirections.marketplace;
}

  /* método para copiar y pegar */
  getClipboard() {
    navigator.clipboard.readText()
      .then((text) => {
        console.log('clipboard contents', text);
        this.parseClipboardText(text);
      })
      .catch(err => {
        console.error('Failed to read clipboard contents: ', err);
      });
  }

  /* Función para analizar el texto del portapapeles */
  private parseClipboardText(text: string) {
    const lines = text.split('\n');
    const dataParsed:clipBoardIPJ = {
        nombre : {
          nombresTitular: '',
          primerApellido:'',
          segundoApellido: ''
        },
      razonSocial: '',
      mail: '',
      rutEmpresa: '',
      cuenta: '',
      banco:{
        id: 0,
        descripcion:''
    } ,
    tipoCuenta: undefined
    };

    console.log(lines);
    console.log('---------------');

    dataParsed.rutEmpresa = this.getRutClip(lines);
    dataParsed.nombre= this.getNombresYApellidos(lines);
    dataParsed.razonSocial= this.getRazonSocial(lines);
    dataParsed.cuenta = this.getCuentaClip(lines);
    dataParsed.banco = this.getBancoClip(lines);
    dataParsed.tipoCuenta = this.getTipoCuentaClip(lines);

    console.log('---------------');
    console.log(lines);

    return dataParsed;
  }

  /* Funciones de extracción de datos (modificadas para retornar valores) */
  private getRazonSocial(lines: string[]) {        
       let result = '-'
        if ( !lines ||  lines.length === 0){
          return result;
        }
          const line = lines[0] ;
          /**EMPRESA  */
          result= line.trim();
        //lines.splice(0, 1);
        return result;
  }
  private getNombresYApellidos(lines: string[]) {            
    const detalleNombre : {
     // nombreCompleto:string,
      nombre : {
          nombresTitular: string;
          primerApellido:string;
          segundoApellido:string;
        }
     }={
      nombre:{nombresTitular:'',primerApellido:'',segundoApellido:''}
     };
     if ( !lines ||  lines.length === 0){
       return detalleNombre.nombre;
     }

     const words = lines[0].trim().split(' ');
     if (words.length >= 2) {
         if (words.length === 2) {
           detalleNombre.nombre.nombresTitular = words[0];
           detalleNombre.nombre.primerApellido = words[1];
         } else if (words.length === 3) {
           detalleNombre.nombre.nombresTitular = words[0];
           detalleNombre.nombre.primerApellido = words[1];
           detalleNombre.nombre.segundoApellido = words[2];
         } else if (words.length === 4) {
           detalleNombre.nombre.nombresTitular = words[0] + ' ' + words[1];
           detalleNombre.nombre.primerApellido = words[2];
           detalleNombre.nombre.segundoApellido = words[3];
         } else if (words.length === 5) {
           detalleNombre.nombre.nombresTitular = words[0] + ' ' + words[1] + ' ' + words[2];
           detalleNombre.nombre.primerApellido = words[3];
           detalleNombre.nombre.segundoApellido = words[4];
         }
         return detalleNombre.nombre;  
      }
  }


  private getMailClip(lines: string[]) {
    for (let i = 0; i < lines.length; i++) {
      lines[i] = lines[i].replace('\r', '').trim();
      if (lines[i].match(/^[a-zA-Z0-9]{1,}[a-zA-Z0-9_\-\\.~]*@[a-zA-Z0-9_\-\\.~]{1,}\.[a-zA-Z]{2,4}$/)) {
        const email = lines[i];
        //lines.splice(i, 1);
        return email;
      }
    }
    return '-';
  }

  private getRutClip(lines: string[]) {
    for (let i = 0; i < lines.length; i++) {
      lines[i] = lines[i].replace('.', '');
      if (lines[i].match(/^[0-9]+[-|‐]{1}[0-9kK]{1}$/)) {
        const rut = lines[i];
        lines.splice(i, 1);
        return rut;
      }
    }
    return '-';
  }


  private getCuentaClip(lines: string[]) {
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].toString().replace(/\D/g, '');
      if (line.length > 0 && !isNaN(Number(line))) {
        const cuenta = line;
        lines.splice(i, 1);
        return cuenta;
      }
    }
    return '-';
  }

  private getBancoClip(lines: string[]) {
    for (const line of lines) {
      const banco = this.bancos.find(b => line.toLowerCase().includes(b.asString.toLowerCase()));
      if (banco) return { id: banco.id, descripcion: banco.asString };
    }
    return { id: 0, descripcion: '-' };
  }

  private getTipoCuentaClip(lines: string[]):TipoCuenta {
    for (const line of lines) {
      const tipoCuenta = this.tiposCuentasDefinidos.find(tc => line.toLowerCase().includes(tc.descripcion.toLowerCase()));
      if (tipoCuenta) return tipoCuenta;
    }
    return undefined;
  }



}
